// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';
// import { logout } from '../../Slice/AdminAuthSlice';

// function Navbar() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.adminAuth);

//   const handleLogout = () => {
//     dispatch(logout());
//     navigate('/login');
//   };

//   return (
//     <nav className="bg-blue-600 text-white p-4 shadow-md">
//       <div className="container mx-auto flex justify-between items-center">
//         <Link to="/" className="text-xl font-bold">Admin Panel</Link>
//         <div className="space-x-4">
//           {user && (user.role === 'Super-Admin' || user.role === 'Admin') && (
//             <Link to="/admin/add-admin" className="hover:underline">Add Admin</Link>
//           )}
//           <Link to="/admin/profile" className="hover:underline">Profile</Link>
//           <Link to="/admin/u/settings" className="hover:underline">Settings</Link>
//           <button onClick={handleLogout} className="hover:underline">Logout</button>
//         </div>
//       </div>
//     </nav>
//   );
// }

// export default Navbar;


import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { logout } from '../../Slice/AdminAuthSlice';

function Navbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.adminAuth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
    setIsProfileDropdownOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  const navLinks = [
    ...(user && (user.role === 'Super-Admin' || user.role === 'Admin') 
      ? [{ path: '/admin/add-admin', label: 'Manage Admins', icon: 'fas fa-users-cog' }] 
      : []),
    { path: '/admin/profile', label: 'Profile', icon: 'fas fa-user' },
    { path: '/admin/u/settings', label: 'Settings', icon: 'fas fa-cog' },
  ];

  return (
    <motion.nav
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className=" shadow-2xl sticky top-0 z-50 backdrop-blur border-b border-white/20 "
    >
      <div className="container mx-auto px-4 lg:px-6">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link 
              to="/" 
              className="flex items-center space-x-3 text-white font-bold text-xl group"
            >
              <motion.div
                className="flex items-center justify-center "
              >
                <a href="/">
            <img src="/assets/Logo/d5artWhite.png" className="w-24 " alt="Logo" />
          </a>
              </motion.div>
              {/* <span className="hidden sm:block group-hover:text-purple-200 transition-colors duration-300">
                Admin Portal
              </span> */}
            </Link>
          </motion.div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link, index) => (
              <motion.div
                key={link.path}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}>
                <Link
                  to={link.path}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-300 group ${
                    isActiveLink(link.path)
                      ? 'bg-white bg-opacity-20 text-white shadow-lg backdrop-blur-sm'
                      : 'text-purple-100 hover:bg-white hover:bg-opacity-10 hover:text-white'
                  }`} 
                >
                  <i className={`${link.icon} text-sm group-hover:scale-110 transition-transform duration-200`}></i>
                  <span className="font-medium">{link.label}</span>
                </Link>
              </motion.div>
            ))}
          </div>

          {/* Profile Dropdown */}
          <div className="hidden md:block relative ">
            <motion.button
              onClick={toggleProfileDropdown}
              className="flex items-center space-x-3 px-4 py-2 rounded-lg bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-300 text-white backdrop-blur-sm"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="w-8 h-8 bg-purple-300 rounded-full flex items-center justify-center">
                <span className="text-purple-800 font-bold text-sm">
                  {user?.name?.charAt(0) || 'A'}
                </span>
              </div>
              <div className="text-left">
                <div className="text-sm font-medium">{user?.name || 'Admin'}</div>
                <div className="text-xs text-purple-200">{user?.role || 'Role'}</div>
              </div>
              <motion.i
                className={`fas fa-chevron-down transition-transform duration-200 ${
                  isProfileDropdownOpen ? 'rotate-180' : ''
                }`}
              ></motion.i>
            </motion.button>

            <AnimatePresence>
              {isProfileDropdownOpen && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.95, y: -10 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.95, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="absolute right-0 mt-2 w-48  rounded-xl shadow-2xl border border-gray-100/30 bg-black overflow-hidden z-50"
                >
                  <div className="px-4 py-3 border-b border-gray-100">
                    <div className="text-sm font-medium text-gray-900">{user?.name}</div>
                    <div className="text-xs text-gray-500">{user?.email}</div>
                    <div className="text-xs text-purple-600 font-medium mt-1">{user?.role}</div>
                  </div>
                  <motion.button
                    onClick={handleLogout}
                    className="w-full px-4 py-3 text-left text-red-600 transition-colors duration-200 flex items-center space-x-2"
                    whileHover={{ x: 4 }}
                  >
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Sign out</span>
                  </motion.button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* Mobile menu button */}
          <motion.button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg text-white hover:bg-white hover:bg-opacity-10 transition-colors duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.i
              className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}
              animate={{ rotate: isMenuOpen ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            ></motion.i>
          </motion.button>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="md:hidden overflow-hidden bg-white bg-opacity-10 backdrop-blur-sm rounded-lg mt-2 mb-4"
            >
              <div className="px-4 py-4 space-y-3">
                <div className="flex items-center space-x-3 pb-4 border-b border-white border-opacity-20">
                  <div className="w-10 h-10 bg-purple-300 rounded-full flex items-center justify-center">
                    <span className="text-purple-800 font-bold">
                      {user?.name?.charAt(0) || 'A'}
                    </span>
                  </div>
                  <div>
                    <div className="text-white font-medium">{user?.name || 'Admin'}</div>
                    <div className="text-purple-200 text-sm">{user?.role || 'Role'}</div>
                  </div>
                </div>

                {/* Navigation links */}
                {navLinks.map((link, index) => (
                  <motion.div
                    key={link.path}
                    initial={{ x: -50, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <Link
                      to={link.path}
                      onClick={() => setIsMenuOpen(false)}
                      className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-300 ${
                        isActiveLink(link.path)
                          ? 'bg-white bg-opacity-20 text-white'
                          : 'text-purple-100 hover:bg-white hover:bg-opacity-10 hover:text-white'
                      }`}
                    >
                      <i className={`${link.icon} text-lg`}></i>
                      <span className="font-medium">{link.label}</span>
                    </Link>
                  </motion.div>
                ))}

                {/* Logout button */}
                <motion.button
                  onClick={handleLogout}
                  className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-red-200 hover:bg-red-500 hover:bg-opacity-20 transition-all duration-300"
                  initial={{ x: -50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: navLinks.length * 0.1 }}
                >
                  <i className="fas fa-sign-out-alt text-lg"></i>
                  <span className="font-medium">Sign out</span>
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Click outside handler for profile dropdown */}
      {isProfileDropdownOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsProfileDropdownOpen(false)}
        ></div>
      )}
    </motion.nav>
  );
}

export default Navbar;